import { LeadBudgetDto } from '@sr/dto';
import { fetchLeadBudgets } from 'entities/lead/api';
import { useReadOnlyRemoteCollection } from 'utils/remote-collection.hook';

export const useLeadBudgets = () => {
  return useReadOnlyRemoteCollection<LeadBudgetDto>({
    fetchHandler: fetchLeadBudgets
  });
};
